import { SelectOptionType } from '@config/type'
import cn from 'classnames'
import { GroupBase, MultiValueProps } from 'react-select'

import styles from './select-tag-item.module.css'

export const SelectTagItem = (
  props: MultiValueProps<
    SelectOptionType<string>,
    boolean,
    GroupBase<SelectOptionType<string>>
  >
) => {
  const selectOptions = props.selectProps.value as SelectOptionType<string>[]
  const currentIdx = props.index
  const hasComma = currentIdx < selectOptions.length - 1

  return (
    <span className={cn(styles.container)}>
      {props.children}
      {hasComma && ','}
    </span>
  )
}
